module.exports = __webpack_public_path__ + "img/pvc_expodots_0020_black.3d4e206e.jpg";